import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserInterface } from 'src/app/models/user.interface';
import { UserService } from 'src/app/core/services/user.service';
import { formatRut, validateRut } from 'rutlib';

function validarRUT(control: AbstractControl) {
  const rut = control.value;
  if (rut) {
    if (!validateRut(rut)) {
      return { rutInvalido: 'Ingresa un RUT válido' };
    }
  }
  return null;
}

@Component({
  selector: 'globot-user-billing',
  templateUrl: './user-billing.component.html',
  styleUrls: ['./user-billing.component.scss'],
})
export class UserBillingComponent implements OnInit {
  @Input() user?: UserInterface;
  hasBillingInfo: boolean = false;
  subscriptionForm: FormGroup;
  planType: string = '';
  planPrice: string = '';
  countries = [
    { name: 'Chile', flag: '🇨🇱', dial_code: '56' },
    { name: 'Argentina', flag: '🇦🇷', dial_code: '54' },
    { name: 'Perú', flag: '🇵🇪', dial_code: '51' },
    { name: 'Venezuela', flag: '🇻🇪', dial_code: '58' },
  ];

  selectedCountry: string = '';
  isLoading: boolean = true;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private route: ActivatedRoute
  ) {
    this.subscriptionForm = this.fb.group({
      email: [''],
      name: ['', [Validators.required]],
      document_value: ['', [Validators.required, validarRUT]],
      phone: ['', [Validators.required]],
      type_document: ['DNI'],
      country: ['56'],
    });
    this.selectedCountry = this.subscriptionForm.controls['country'].value;
  }

  ngOnInit() {
    const user = this.userService.getUserLocalStorage();
    if (user) {
      this.subscriptionForm.controls['email'].setValue(user.email || '');
      this.subscriptionForm.controls['name'].setValue(user.name_on_invoice || '');
      this.subscriptionForm.controls['document_value'].setValue(user.document_value || '');
      let phoneNumber = user.phone_number || '';
      let countryDialCode = '56'; // default to Chile

      for (let country of this.countries) {
        if (phoneNumber.startsWith(country.dial_code)) {
          countryDialCode = country.dial_code;
          phoneNumber = phoneNumber.substring(country.dial_code.length);
          break;
        }
      }

      this.subscriptionForm.controls['phone'].setValue(phoneNumber);
      this.subscriptionForm.controls['country'].setValue(countryDialCode);
    }
    this.isLoading = false;
  }

  onblur() {
    const rut = this.subscriptionForm.get('document_value')?.value;
    this.subscriptionForm.controls['document_value'].setValue(formatRut(rut));
  }
  getCodeNumber(): string {
    const code = this.subscriptionForm.get('country')?.value;

    return '+(' + code + ')';
  }

  onCountryChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedCountry = selectElement.value;
  }
}
